import de from '@translations/de/points.json';
import en from '@translations/en/points.json';
import pl from '@translations/pl/points.json';
import sl from '@translations/sl/points.json';
import uk from '@translations/uk/points.json';
import bg from '@translations/bg/points.json';
import cz from '@translations/cz/points.json';
import fr from '@translations/fr/points.json';
import gr from '@translations/gr/points.json';
import it from '@translations/it/points.json';
import pr from '@translations/pr/points.json';
import ru from '@translations/ru/points.json';
import sk from '@translations/sk/points.json';
import sp from '@translations/sp/points.json';
import tr from '@translations/tr/points.json';
import hu from '@translations/hu/points.json';
import { ITranslations } from '@/types/common';
import { PointsTransFields } from './types';

export const pointsTranslations: ITranslations<PointsTransFields> = {
  name: 'points',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
